import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import {
    COFIDIS_MERCHANT_ID,
    COFIDIS_PROVIDER_ID,
    PRIMARY_COLOR,
    SHOW_EFCONSENT
} from '../../../../constants';
import { COFIDIS } from '../../../../constants/paymentMethods';
import { INSTALLMENTS_3X, INSTALLMENTS_4X } from '../../../../services/cofidis/constants';

import {
    callEligibility,
    callInitialize,
    setMerchantTransactionId,
    setRequestId
} from '../../../../services/cofidis/actions';

import { convertHtmlToReactDomWithParams } from '../../../../utils/htmlUtils';
import { randomNumber, randomString, mapCofidisCart } from '../../../../services/cofidis/utils';

import CardsPicto from './CardsPicto';
import { LoadingComponent } from '../../../loading/LoadingComponent';

import { CofidisContainer } from './CofidisStyle';

const Cofidis = ({
    selectedMethod,
    handleMethodChange,
    cartTotalValue,
    i18n,
    setRequestId,
    setMerchantTransactionId,
    eligible,
    callEligibility,
    callInitialize,
    order,
    fetchingEligibility,
    cofidisCart
}) => {
    const [value, setValue] = useState(INSTALLMENTS_3X);
    const [isEligible, setEligible] = useState(false);

    const cofidisCommonData = {
        orderId: order.id,
        amount: (cartTotalValue * 100).toFixed().replace('.', ','),
        customerRate: 'FREE',
        paymentMethod: 'CARD'
    };

    const isCofidisSelected = () => {
        return selectedMethod === COFIDIS;
    };
    const isSdkLoaded = () => {
        return document.getElementById('cofidis-sdk') !== (undefined || null);
    };

    // Initialize on first diplay
    useEffect(() => {
        sendEligibility(value);
        sendInitialize(value);
    }, []);

    useEffect(() => {
        if (isCofidisSelected()) {
            createFieldCofidis(value);
        } else {
            document.querySelectorAll('iframe').forEach(e => e.remove());
        }
    }, [selectedMethod]);

    const sendInitialize = paymentOption => {
        const data = {
            ...cofidisCommonData,
            paymentOption: paymentOption,
            requestId: randomString(),
            merchantTransactionId: randomNumber()
        };
        setRequestId(data.requestId);
        setMerchantTransactionId(data.merchantTransactionId);

        callInitialize(data);
    };
    const sendEligibility = paymentOption => {
        const data = {
            ...cofidisCommonData,
            paymentOption: paymentOption,
            items: cofidisCart
        };

        callEligibility(data);
    };

    const changeInstallments = paymentOption => {
        document.querySelectorAll('iframe').forEach(e => e.remove());

        setValue(paymentOption);
        sendEligibility(paymentOption);
        sendInitialize(paymentOption);
        createFieldCofidis(paymentOption);
    };

    // Installment choice (3X or 4X) iframe
    const createFieldCofidis = paymentOption => {
        setEligible(true);
        if (eligible) {
            if (!document.querySelector('iframe')) {
                var bloc_simulation = new window.papi.EFSimulation({
                    paymentOption: paymentOption,
                    customerRate: 'FREE',
                    merchantCountry: 'FR',
                    hostElement: document.getElementById('EFSimulation'),
                    mode: 'circle',
                    customization: {
                        circleColor: '' + PRIMARY_COLOR + '',
                        textSize: '16px'
                    }
                });
                bloc_simulation.iframe.height = '180';

                if (SHOW_EFCONSENT) {
                    new window.papi.EFConsent({
                        merchantId: COFIDIS_MERCHANT_ID,
                        providerId: COFIDIS_PROVIDER_ID,
                        orderId: order.id.replaceAll('-', '').substr(0, 15),
                        paymentOption: paymentOption,
                        consents: ['cookies'],
                        hostElement: document.getElementById('EFConsent'),
                        iframeWidth: '100%',
                        iframeHeight: '90'
                    });
                }
            }
        }
    };

    return (
        isSdkLoaded &&
        (eligible || isEligible) && (
            <CofidisContainer>
                <div className="text" onClick={() => handleMethodChange(COFIDIS)}>
                    <div>
                        <input
                            type="radio"
                            id="cofidis"
                            name="cofidis"
                            value={COFIDIS}
                            className="vertical-centre"
                            disabled={!eligible}
                            checked={selectedMethod === COFIDIS}
                        />
                        <label htmlFor="cofidis" className="vertical-centre">
                            {convertHtmlToReactDomWithParams(i18n.PAYMENT_CHOICE.COFIDIS)}
                        </label>
                    </div>
                    <CardsPicto />
                </div>
                <div className="text-choice">
                    {i18n.PAYMENT_CHOICE.PAY_IN}
                    <button
                        className="btn-choice"
                        disabled={!isCofidisSelected() || value === INSTALLMENTS_3X}
                        onClick={() => {
                            changeInstallments(INSTALLMENTS_3X);
                        }}>
                        {i18n.PAYMENT_CHOICE.LESS}
                    </button>
                    {value}
                    <button
                        className="btn-choice"
                        disabled={!isCofidisSelected() || value === INSTALLMENTS_4X}
                        onClick={() => {
                            changeInstallments(INSTALLMENTS_4X);
                        }}>
                        {i18n.PAYMENT_CHOICE.PLUS}
                    </button>
                </div>
                <div id="iframeContainer">
                    <div id="EFSimulation"></div>
                    <div id="EFConsent"></div>
                </div>
                {fetchingEligibility && (
                    <div className="loading">
                        <LoadingComponent />
                    </div>
                )}
            </CofidisContainer>
        )
    );
};

Cofidis.propTypes = {
    selectedMethod: PropTypes.string,
    handleMethodChange: PropTypes.func,
    cartTotalValue: PropTypes.number
};

const mapStateToProps = state => {
    return {
        i18n: state.i18n.page.EBON,
        order: state.ebon.createdOrder,
        eligible: state.cofidis.eligible,
        fetchingEligibility: state.cofidis.fetchingEligibility,
        cofidisCart: mapCofidisCart(state.ebon.cart, state.ebon.ebonPartners)
    };
};

const mapDispatchToProps = {
    setRequestId,
    setMerchantTransactionId,
    callEligibility,
    callInitialize
};

export default connect(mapStateToProps, mapDispatchToProps)(Cofidis);



// WEBPACK FOOTER //
// ./src/components/funnel/payment-selection-step/payment-choice/Cofidis.js